import React from "react";
import styles from "./FeaturesSection.module.css";
import { FEATURES_HTML } from "../../../content/marketingCopy";

export default function FeaturesSection() {
  return (
    <section id="features" className={`py-5 ${styles.features}`} aria-labelledby="features-heading">
      <div className="container">
        <div className="row justify-content-center mb-3">
          <div className="col-12 col-lg-9 text-center">
            <h2 id="features-heading" className="h3 fw-bold mb-1">Features</h2>
            <p className="text-body-secondary mb-0">Everything you need to track, plan, and forecast</p>
          </div>
        </div>

        {/* Keep your existing HTML injection (cards grid) */}
        <div
          className={`row g-3 g-lg-4 ${styles.grid}`}
          dangerouslySetInnerHTML={{ __html: FEATURES_HTML }}
          aria-label="Pocket Penny capabilities"
        />
      </div>
    </section>
  );
}
